import { createFileRoute, useParams } from "@tanstack/react-router";
import { BillDetailPage } from "@/components/inventory/BillDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/bills_/$id")({
  component: AdminBillDetail,
});

function AdminBillDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/bills_/$id" });
  return <BillDetailPage billId={id} />;
}
